<template>
    <div>
        <v-img :src="src" v-if="src" onerror="style.display:'none'" :style="cssStyle" />
    </div>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import GET_LOGO_URL from "@/graphql/GetLogoUrl.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({})
export class PublicCompanyLogoView extends Vue {
    @Prop() companyId: string;
    @Prop({ default: "" }) cssStyle: string;

    @Apollo({
        query: GET_LOGO_URL,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data.getLogoUrlWithoutAuth?.signedUrl) {
                this.src = data.getLogoUrlWithoutAuth.signedUrl;
            }
        },
    })
    src: string = "";
}

export default toNative(PublicCompanyLogoView);
</script>
